/* MEAMA cart drawer: personal offers (snippets/meama-cart-offers.liquid).
   Cards come from the signed-in customer's custom.active_offer codes. No codes = the block stays hidden (CSS).
   A card applies its code with /cart/update.js {discount}; Shopify decides eligibility (discount_codes[].applicable).
   One offer is applied automatically unless the cart already has a code or the shopper removed it. */
(function () {
  if (customElements.get('meama-cart-offers')) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CHOICE = '_meama_offer_choice';

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }); }
  function applicable(cart, code) {
    return (cart.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
  }
  function refreshDrawer(cart) {
    try { if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'meama-cart-offers', cart: cart }); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
  }

  customElements.define('meama-cart-offers', class extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.mcdx-offers-card[data-offer-code]'));
      if (!this.cards.length) return;
      this.mine = this.cards.map(function (c) { return c.getAttribute('data-offer-code'); });
      this.errorEl = this.querySelector('[data-offer-error]');
      this.busy = false;
      var self = this;
      this.cards.forEach(function (c) { c.addEventListener('click', function () { self.toggle(c); }); });
      this.setupTrack();
      var count = this.querySelector('[data-offer-count]');
      if (count && this.cards.length > 1) count.textContent = this.cards.length;
      var hint = this.querySelector('[data-offer-hint]');
      if (hint) hint.textContent = hint.getAttribute(this.cards.length > 1 ? 'data-multiple' : 'data-single') || '';
      getCart().then(function (cart) {
        self.paint(cart);
        var choice = (cart.attributes || {})[CHOICE] || '';
        // auto-apply a single offer once: not if any code is already on the cart or the shopper took it off
        if (self.cards.length === 1 && !codesOf(cart).length && choice !== 'none') self.apply(self.mine[0], cart, true);
      }).catch(function () {});
    }

    paint(cart) {
      var self = this;
      this.cards.forEach(function (c) {
        var on = applicable(cart, c.getAttribute('data-offer-code'));
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        var st = c.querySelector('[data-offer-status]');
        if (st) st.textContent = on ? self.dataset.selected : self.dataset.select;
      });
    }

    error(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg || '';
      this.errorEl.hidden = !msg;
    }

    toggle(card) {
      if (this.busy) return;
      var code = card.getAttribute('data-offer-code'), self = this;
      getCart().then(function (cart) {
        if (applicable(cart, code)) self.remove(code, cart); else self.apply(code, cart, false);
      });
    }

    apply(code, cart, quiet) {
      var self = this, mine = this.mine.map(function (x) { return x.toLowerCase(); });
      var before = codesOf(cart);
      // one personal offer at a time; other codes already on the cart stay
      var next = before.filter(function (x) { return mine.indexOf(x.toLowerCase()) === -1; }).concat([code]);
      this.busy = true; this.error('');
      var card = this.cards[this.mine.indexOf(code)], st = card && card.querySelector('[data-offer-status]');
      if (st) st.textContent = this.dataset.applying;
      var attrs = {}; attrs[CHOICE] = code;
      post('cart/update.js', { discount: next.join(','), attributes: attrs }).then(function (res) {
        if (applicable(res, code)) { self.busy = false; self.paint(res); refreshDrawer(res); return; }
        // Shopify refused it for this cart: put the previous codes and choice back
        var undo = {}; undo[CHOICE] = (cart.attributes || {})[CHOICE] || '';
        return post('cart/update.js', { discount: before.join(','), attributes: undo }).then(function (back) {
          self.busy = false; self.paint(back);
          if (!quiet) self.error(self.dataset.ineligible);
        });
      }).catch(function () { self.busy = false; self.paint(cart); if (!quiet) self.error(self.dataset.error); });
    }

    remove(code, cart) {
      var self = this;
      var next = codesOf(cart).filter(function (x) { return x.toLowerCase() !== code.toLowerCase(); });
      this.busy = true; this.error('');
      var attrs = {}; attrs[CHOICE] = 'none';
      post('cart/update.js', { discount: next.join(','), attributes: attrs }).then(function (res) {
        self.busy = false; self.paint(res); refreshDrawer(res);
      }).catch(function () { self.busy = false; self.error(self.dataset.error); });
    }

    setupTrack() {
      var track = this.querySelector('[data-offer-track]'), arrows = this.querySelector('[data-offer-arrows]');
      if (!track || !arrows) return;
      var prev = arrows.querySelector('[data-offer-scroll="-1"]'), next = arrows.querySelector('[data-offer-scroll="1"]');
      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        arrows.hidden = max <= 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      arrows.addEventListener('click', function (e) {
        var b = e.target.closest('[data-offer-scroll]'); if (!b) return;
        var card = track.querySelector('.mcdx-offers-card');
        track.scrollBy({ left: (card ? card.offsetWidth + 8 : 160) * +b.getAttribute('data-offer-scroll'), behavior: 'smooth' });
      });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      requestAnimationFrame(sync);
    }
  });
})();
